import { jsx as u } from "react/jsx-runtime";
import { c as o } from "./themes-5f0b3c3d.mjs";
import "react";
import { u as c } from "./index-6a632112.mjs";
const m = (t) => {
  if (t.includes("/")) {
    const e = t.split("/");
    return `${Number(e[1]) / Number(e[0]) * 100}%`;
  }
  if (t.includes(":")) {
    const e = t.split(":");
    return `${Number(e[1]) / Number(e[0]) * 100}%`;
  }
  return t;
}, d = c.div`
  ${({ $ratio: t = "100%", minHeight: e, maxHeight: i, $objectFit: n = "contain" }) => `
    position: relative;
    width: 100%;
    padding-bottom: ${m(t)};
    min-height: ${e};
    max-height: ${i};

    * {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: ${n};
    }
    `};

  background-color: ${(t) => {
  switch (t.$variant) {
    case "neutral":
      return o.brandTwilight[500];
    case "default":
      return o.brandTwilight[400];
    case "none":
      return "unset";
    default:
      return "unset";
  }
}};
`, g = ({
  ratio: t = "100%",
  minHeight: e,
  maxHeight: i,
  objectFit: n = "contain",
  variant: r = "none",
  className: a = "",
  children: s
}) => /* @__PURE__ */ u(
  d,
  {
    $ratio: t,
    $minHeight: e,
    $maxHeight: i,
    $objectFit: n,
    $variant: r,
    children: s,
    className: a
  }
);
export {
  g as AspectRatio
};
